import apiRequest from '../../utils/bccampusGraphQLRequest';
import { CreateFormSubmissionMutation, GetFormByKeyQuery } from '../queries/FormSubmissions.graphql';

const read = async (key) => {
  const variables = {
    key: key,
  };
  const result = await apiRequest(GetFormByKeyQuery, variables);
  return result.forms.length === 1 ? result.forms[0] : null;
}

const create = async (data) => {
  const variables = {
    data: data
  };
  const result = await apiRequest(CreateFormSubmissionMutation, variables);
  return result.createFormSubmission;
}

const repository = { read, create };

export { read, create }
export default repository
